export const tags = {
  headerByDocId: (id: string) => `header-${id}`,
  footerByDocId: (id: string) => `footer-${id}`,
  pageByDocId: (id: string) => `page-${id}`,
  blogTopicByDocId: (id: string) => `blog-topic-${id}`,
  blogTopicBySlug: (slug: string) => `blog-topic-slug-${slug}`,
  pageBySlug: (slug: string) => `page-slug-${slug}`,
  blogBySlug: (slug: string) => `blog-slug-${slug}`,
  modals: (locale: string) => `modals-${locale}`,
  redirects: () => 'redirects',
  experiments: () => 'experiments',
  socialWidget: () => 'social-widget',
};
